// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Text({ value }) {
  return (
    <div className="text--container">
      <p className="text--container__paragraphe">{value}</p>
    </div>
  );
}

Text.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Text;
